<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    :title="openType === 'add' ? '新增类型' : '编辑类型'"
    custom-class="customModal">
    <AppForm
      v-if="visible"
      ref="form"
      :fields="formFields"
      :rules="rules"
      :defaultValues="defaultValues"
      @cancel="cancel"
      @submit="submit"/>
  </el-dialog>
</template>

<script>
import { CategoriesService } from '../../service/categories.service';
import { GoodsService } from '../../service/goods.service';
  export default {
    name: 'formCategories',
    data() {
      return {
        openType: 'add',
        treeData: [],
        visible: false,
        defaultValues: {},
        rules: {
          name: [{ required: true, message: '权限名称不能为空'}],
          mobile_name: [{ required: true, message: '手机端显示名称不能为空'}],
          sort_order: [{ required: true, message: '排序不能为空'}],
          parent_id: [{ required: true, message: '父级分类不能为空'}],
          icon: [{ required: true, message: '图标不能为空'}],
          image: [{ required: true, message: '图标不能为空'}],
        },
        formFields: [
          { type: 'input', key: 'name', label: '分类名称', span: 24 },
          { type: 'input', key: 'mobile_name', label: '手机端显示名称', span: 24 },
          { type: 'input', key: 'icon', label: '图标', span: 24 },
          { type: 'image', key: 'image', pathType: 'goods_cat', label: '首页大图', limit: 1, span: 24 },
          { type: 'input', key: 'sort_order', label: '排序', span: 24 },
          { type: 'cascader', key: 'parent_id', label: '父级分类', span: 24, options: [] },
        ]
      }
    },
    created() {
      this.getTreeData()
    },
    methods: {
      open(openType, data) {
        this.openType = openType;
        if (openType === 'edit') {
          delete data.sub;
          this.defaultValues = JSON.parse(JSON.stringify(data));
          this.defaultValues.parent_id = CategoriesService.searchTreeParent(this.treeData, data.parent_id);
          this.defaultValues.image = [{
            uid: 1,
            name: '图片异常',
            status: 'done',
            url: CategoriesService.spliceImg(data.image),
          }];
        } else {
          this.defaultValues = {};
        }
        this.visible = true;
      },
      async getTreeData() {
        const data = await GoodsService.categoryList();
        this.formFields[5].options = [{ id: 0, name: '根分类', sub: data}];
        this.formFields = [...this.formFields];
        this.treeData = [{ id: 0, name: '根分类', sub: data}];
      },
      cancel() {
        this.defaultValues = null;
        this.visible = false;
      },
      async submit(data) {
        const reqData = Object.assign({}, data);
        reqData.parent_id = reqData.parent_id.pop();
        await CategoriesService.save(reqData);
        this.$emit('success');
        this.cancel();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>